module.exports = __webpack_public_path__ + "static/media/friend_finder_landing_page.a4f19774.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/friend_finder_landing_page.png
// module id = 41
// module chunks = 0